import { TicketBaseDto, useRestApiProvider } from "@jugl-web/rest-api";
import { transformTicketListItemDtoToModel } from "@jugl-web/rest-api/tickets/models";
import { TicketsApiTag } from "@jugl-web/rest-api/tickets/tags";
import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { emitTicketMutationEvent } from "../events/ticketMutation";

type TicketLiveUpdateType = "created" | "updated" | "deleted";

/**
 * Invalidates ticket details and inbox stats, then emits a list mutation event
 * so subscribed ticket lists can be updated accordingly.
 */
export const useApplyTicketLiveUpdate = () => {
  const { ticketsApi } = useRestApiProvider();
  // oxlint-disable-next-line typescript/no-explicit-any
  const dispatch = useDispatch<ThunkDispatch<any, unknown, AnyAction>>();

  return useCallback(
    (type: TicketLiveUpdateType, ticket: TicketBaseDto) => {
      dispatch(
        ticketsApi.util.invalidateTags([
          { type: TicketsApiTag.ticket, id: ticket.id },
          TicketsApiTag.ticketsStats,
        ])
      );

      if (type === "deleted") {
        emitTicketMutationEvent({ type: "deleted", ticketId: ticket.id });
        return;
      }

      emitTicketMutationEvent({
        type,
        ticket: transformTicketListItemDtoToModel(ticket),
      });
    },
    [dispatch, ticketsApi]
  );
};
